var AreaCalc = AreaCalc || (function ($) {

    var options;

    var extractPrice = function (field) {
        var txtPrice = field.text().replace(/[^0-9\.,]/g, '').replace(',', '.');
        return parseFloat(txtPrice);
    };

    var toTwoDecComma = function (flt) {
        return flt.toFixed(2).replace('.', ',');
    };

    var tryParseFloat = function (str) {
        var str1 = str.trim().replace(',', '.');
        try {
            return parseFloat(str1) || 0.0;
        } catch (ex) {
            return 0.0;
        }
    };

    var intOrDefault = function (str, def) {
        if (!str || str.length === 0) {
            return def;
        }

        var i = parseInt(str);

        if (i.isNaN) {
            return def;
        }

        return i;
    };

    var disableCartQuantity = function () {
        var cartCont = $('.UC110MainContainer');

        if (!cartCont || cartCont.length === 0) {
            return;
        }

        cartCont.find('.CartGridItemQuantity').attr('disabled', 'disabled');
    };

    var tryInitSquareFromPackagesCalculator = function ($main, $customFields) {
        var $inpm2PrPakke = $('input[name$="m2PrPakke"]', $customFields);
        var $inppkgCount = $('input[name$="pkgCount"]', $customFields);

        if (!$inpm2PrPakke || $inpm2PrPakke.length === 0) {
            return false;
        }

        var m2PrPkg = parseFloat(($inpm2PrPakke.val() || '0').replace(',', '.'));

        if (m2PrPkg.isNaN || (m2PrPkg < 0.00000001 && m2PrPkg > -0.00000001)) {
            return false;
        }

        //Declare controls
        var $txbQuantity = $main.find(options.squareFromPackagesCalculator.quantityInputSelector).val('0');
        var $fPrice = $main.find(options.squareFromPackagesCalculator.priceSelector);
        var $divMakeOrderContainer = $main.find(options.squareFromPackagesCalculator.insertCalcBeforeContainer);

        if (options.squareFromPackagesCalculator && options.squareFromPackagesCalculator.quantityHideSelfNotParent === true) {
            $txbQuantity.hide();
        } else {
            $txbQuantity.parent().hide();
        }

        //Calculate some values
        var price = extractPrice($fPrice);
        var pricePrPkg = price * m2PrPkg;
        if (options.squareFromPackagesCalculator.appendUnitTextToMainPrice === true) {
            $fPrice.html(price.toMoney() + '&nbsp;pr.&nbsp;m<sup>2</sup>');
        }

        //Add new controls
        var $divCalc = $('<div class="square-calc a1"></div>').insertBefore($divMakeOrderContainer);
        $divCalc.append('<h3 class="square-calc__heading">Gulvkalkulator</h3>');
        $divCalc.append('<div class="square-calc__info-text">Mål opp areal i kvadratmeter (m<sup>2</sup>), og skriv inn i feltet under. Utregning tar høyde for normalt kapp og svinn (' + options.percent + '%).</div>');
        $divCalc.append('<div class="square-calc__price-pr-pkg"><span class="square-calc__key Key">Pris pr. pakke:</span><span class="square-calc__value Value">' + pricePrPkg.toMoney() + '</span></div>');
        $divCalc.append('<div class="square-calc__m2-pr-pkg"><span class="square-calc__key Key">M<sup>2</sup> pr. pakke:</span><span class="square-calc__value Value">' + m2PrPkg.toString().replace('.', ',') + '<span class="square-calc__unit Unit">m<sup>2</sup></span></span></div>');
        $divCalc.append('<div class="square-calc__m2"><div class="square-calc__key Key"><label for="txbArea">Kvadratmeter:</label></div><div class="square-calc__value Value"><input type="text" placeholder="Skriv inn m2" id="txbArea" class="square-calc__input"/><span class="square-calc__unit Unit">m<sup>2</sup></span></div></div>');
        $divCalc.append('<div class="square-calc__m2-calc"><span class="square-calc__key Key">Beregnet:</span><span id="lbCalcArea" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">m<sup>2</sup></span></div>');
        $divCalc.append('<div class="square-calc__pkg-count"><span class="square-calc__key Key">Du trenger:</span><span id="lbPkgCount" class="square-calc__value Value">0</span><span class="square-calc__unit Unit">pakker</span></div>');
        $divCalc.append('<div class="square-calc__calc-price"><span class="square-calc__key Key">Totalpris:</span><span id="lbCalcPrice" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">kr</span></div>');

        var $txbArea = $main.find('#txbArea');
        var $lbCalcArea = $main.find('#lbCalcArea');
        var $lbPkgCount = $main.find('#lbPkgCount');
        var $lbCalcPrice = $main.find('#lbCalcPrice');

        var calcArea = function () {
            //Calculate values
            var m2 = tryParseFloat($txbArea.val());
            var calcM2 = m2 * (100 + options.percent) / 100;
            var pkgCount = Math.ceil(calcM2 / m2PrPkg);
            calcM2 = pkgCount * m2PrPkg;
            var newPrice = calcM2 * price;

            //Update fields
            $lbCalcArea.text(toTwoDecComma(calcM2));
            $lbPkgCount.text(pkgCount);
            $lbCalcPrice.text(toTwoDecComma(newPrice));
            $txbQuantity.val(calcM2.toString());
            $inppkgCount.val(pkgCount);
        };

        var setFromPkgCount = function () {
            //Calculate values
            var pkgCount = intOrDefault($inppkgCount.val(), 0);

            if (pkgCount <= 0) {
                return;
            }

            var calcM2 = pkgCount * m2PrPkg;
            var newPrice = calcM2 * price;

            //Update fields
            $lbCalcArea.text(toTwoDecComma(calcM2));
            $lbPkgCount.text(pkgCount);
            $lbCalcPrice.text(toTwoDecComma(newPrice));
            $txbQuantity.val(calcM2.toString());
        };

        setFromPkgCount();

        $txbArea.bind('keyup blur', calcArea);

        return true;
    };

    var tryInitSquareFromWidthCalculator = function ($main, $customFields) {
        var $divMakeOrderContainer = $main.find('div.MakeOrderContainer');
        var $specifiedLength = $('input[name$="valgtLengde"]', $customFields);
        var $widthSelector = $('select[name$="breddevariant"]', $customFields);
        var $widthOptions = $('option', $widthSelector);
        var $containerCF = $('.customFieldCont', $customFields);

        if (!$widthOptions.length) {
            return false;
        }

        var $txbQuantity = $main.find('input.QuantityTxb').val('0');

        if (options.squareFromPackagesCalculator && options.squareFromPackagesCalculator.quantityHideSelfNotParent === true) {
            $txbQuantity.hide();
        } else {
            $txbQuantity.parent().hide();
        }

        var $fPrice = $main.find('span.PriceValue');
        var priceM2 = extractPrice($fPrice);
        $fPrice.html($fPrice.text() + '&nbsp;pr.&nbsp;m<sup>2</sup>');

        var $divCalc = $('<div class="square-calc a2"></div>').insertBefore($divMakeOrderContainer);
        $divCalc.append('<h3 class="square-calc__heading">Gulvkalkulator</h3>');
        $divCalc.append('<div class="square-calc__info-text">Velg ønsket bredde (m) og skriv inn gulvets lenge (m) i feltet under, og totalpris blir beregnet.</div>');
        $containerCF.append('<div class="square-calc__lengde flex flex-no-wrap flex-item-center"><span class="square-calc__multiply">X</span></div>');
        $containerCF.append('<div class="square-calc__m2-calc flex flex-no-wrap flex-item-center"><div class="square-calc__key Key"><label for="txbLength">Lengde:</label></div><input type="text" id="txbLength" class="square-calc__input"/><span class="square-calc__unit Unit">m</span><span class="square-calc__equals">=</span><span id="lbCalcArea" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">m<sup>2</sup></span></div>');
        $containerCF.append('<div class="square-calc__calc-price flex flex-no-wrap flex-item-center"><span class="square-calc__key Key">Totalpris:</span><span id="lbCalcPrice" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">kr</span></div>');
        $containerCF.detach().appendTo($divCalc);

        if ($('label[for*="breddevariant"]').length || $('select[name*="breddevariant"]').length || $('.square-calc__multiply').length) {
            $('<div class="square-calc__container"></div>').prependTo($('.cfbreddevariant'));
            $('label[for*="breddevariant"]').prependTo('.square-calc__container');
            $('select[name*="breddevariant"]').insertAfter('.square-calc__container label[for*="breddevariant"]');
            $('.square-calc__multiply').insertAfter('.square-calc__container select[name*="breddevariant"]');
        }

        var $txbLength = $containerCF.find('#txbLength');
        var $lbCalcArea = $containerCF.find('#lbCalcArea');
        var $lbCalcPrice = $containerCF.find('#lbCalcPrice');

        var calcArea = function (length) {
            var width = $widthSelector.find('option:selected').val() || 0;
            var square = length * width;
            var totalPrice = priceM2 * square;

            $lbCalcArea.text(toTwoDecComma(square));
            $lbCalcPrice.text(toTwoDecComma(totalPrice));
            $txbQuantity.val(square.toString().replace('.', ','));
        };

        var onLengthWidthChange = function () {
            var length = tryParseFloat($txbLength.val());
            calcArea(length);
            $specifiedLength.val(length);
        };

        var setFromSpecifiedLength = function () {
            var length = tryParseFloat($specifiedLength.val());

            if (length <= 0) {
                return false;
            }

            calcArea(length);
            $txbLength.val(length.toString().replace('.', ','));

            return true;
        };

        var trySetDefaultWidth = function () {
            var defaultWidth = $('input[name$="standardBredde"]', $customFields).val();

            if (defaultWidth) {
                $widthOptions.filter('[value="' + defaultWidth + '"]').attr('selected', 'selected');
            }
        };

        if (!setFromSpecifiedLength()) {
            trySetDefaultWidth();
        }

        $txbLength.bind('keyup blur', onLengthWidthChange);
        $widthSelector.change(onLengthWidthChange);

        return true;
    };


    var tryInitSquareFromRollsCalculator = function ($main, $customFields) {
        var $inpm2PrRoll = $('input[name$="m2PrRoll"]', $customFields);
        var $specifiedTotalWallWidth = $('input[name$="veggbredde"]', $customFields);
        var $specifiedWallHeight = $('input[name$="vegghøyde"]', $customFields);

        if (!$inpm2PrRoll || $inpm2PrRoll.length === 0) {
            return false;
        }

        var m2PrRoll = parseFloat(($inpm2PrRoll.val() || '0').replace(',', '.'));

        if (m2PrRoll.isNaN || (m2PrRoll < 0.00000001 && m2PrRoll > -0.00000001)) {
            return false;
        }

        //Declare controls
        var $txbQuantity = $main.find('input.QuantityTxb').val('0');
        var $divMakeOrderContainer = $main.find('div.MakeOrderContainer');
        var $fPrice = $main.find('span.PriceValue');

        if (options.squareFromPackagesCalculator && options.squareFromPackagesCalculator.quantityHideSelfNotParent === true) {
            $txbQuantity.hide();
        } else {
            $txbQuantity.parent().hide();
        }

        //Calculate some values
        var pricePrRoll = extractPrice($fPrice);
        var pricePrM2 = pricePrRoll / m2PrRoll;
        $fPrice.html($fPrice.text() + '&nbsp;pr.&nbsp;rull</sup>');

        //Add new controls
        var $divCalc = $('<div class="square-calc a3"></div>').insertBefore($divMakeOrderContainer);
        $divCalc.append('<h3 class="square-calc__heading">Tapetkalkulator</h3>');
        $divCalc.append('<div class="square-calc__info-text">Angi total veggbredde(m) og vegghøyde(m) i feltene under.Utregningen tar høyde for svinn (' + options.rollsPercent + '%), og vil oppgi hvor mange enheter som behøves for å dekke totalt vegg - areal.</div>');
        $divCalc.append('<div class="square-calc__price-pr-roll"><span class="square-calc__key Key">Pris pr. rull:</span><span class="square-calc__value Value">' + pricePrRoll.toMoney() + '</span></div>');
        $divCalc.append('<div class="square-calc__container-calculation"><div class="square-calc__total_wall_width"><div class="square-calc__key Key flex flex-item-center flex-no-wrap"><label for="txbTotalWallWidth">Veggbredde (m):</label><input type="text" id="txbTotalWallWidth" class="square-calc__input"/><span class="square-calc__multiply">X</span></div><div class="square-calc__value Value"><div class="square-calc__key Key flex flex-item-center flex-no-wrap"><label for="txbWallHeight">Vegghøyde (m):</label><input type="text" id="txbWallHeight" class="square-calc__input"/></div></div></div></div>');
        $divCalc.append('<div class="square-calc__m2-calc flex flex-no-wrap"><span class="square-calc__key Key">Beregnet veggareal:</span><span id="lbCalcArea" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">m <sup>2</sup></span></div>');
        $divCalc.append('<div class="square-calc__roll-count flex flex-no-wrap"><span class="square-calc__key Key">Du trenger:</span><span id="lbRollCount" class="square-calc__value Value">0</span><span class="square-calc__unit Unit">ruller</span></div>');
        $divCalc.append('<div class="square-calc__calc-price flex flex-no-wrap"><span class="square-calc__key Key">Totalpris:</span><span id="lbCalcPrice" class="square-calc__value Value">0,00</span><span class="square-calc__unit Unit">kr</span></div>');

        var $txbTotalWallWidth = $main.find('#txbTotalWallWidth');
        var $txbWallHeight = $main.find('#txbWallHeight');
        var $lbCalcArea = $main.find('#lbCalcArea');
        var $lbPkgCount = $main.find('#lbRollCount');
        var $lbCalcPrice = $main.find('#lbCalcPrice');

        var calcArea = function () {
            //Calculate values
            var totalWallWidth = tryParseFloat($txbTotalWallWidth.val());
            var wallHeight = tryParseFloat($txbWallHeight.val());
            var m2 = totalWallWidth * wallHeight;
            var calcM2 = m2 * (100 + options.rollsPercent) / 100;
            var rollCount = Math.ceil(calcM2 / m2PrRoll);
            var calcPrice = calcM2 * pricePrM2;

            //Update fields
            $specifiedTotalWallWidth.val(totalWallWidth);
            $specifiedWallHeight.val(wallHeight);

            $lbCalcArea.text(toTwoDecComma(calcM2));
            $lbPkgCount.text(rollCount);
            $lbCalcPrice.text(toTwoDecComma(calcPrice));
            $txbQuantity.val(rollCount.toString().replace('.', ','));
        };

        var setFromSpecifiedFields = function () {
            var totalWallWidth = tryParseFloat($specifiedTotalWallWidth.val());
            var wallHeight = tryParseFloat($specifiedWallHeight.val());

            if (totalWallWidth <= 0 || wallHeight <= 0) {
                return false;
            }

            $txbTotalWallWidth.val(totalWallWidth.toString().replace('.', ','));
            $txbWallHeight.val(wallHeight.toString().replace('.', ','));
            calcArea();

            return true;
        };

        setFromSpecifiedFields();

        $txbTotalWallWidth.bind('keyup blur', calcArea);
        $txbWallHeight.bind('keyup blur', calcArea);

        return true;
    };

    return {
        init: function (o) {

            options = $.extend({
                percent: 5,
                rollsPercent: 5,
                mainContSelector: 'div.UC169',
                customFieldsSelector: 'div.customFieldsCont',
                squareFromPackagesCalculator: {
                    quantityInputSelector: 'input.QuantityTxb',
                    quantityHideSelfNotParent: false,
                    priceSelector: 'span.PriceValue',
                    appendUnitTextToMainPrice: true,
                    insertCalcBeforeContainer: 'div.MakeOrderContainer',
                }
            }, o || {});

            $(function () {
                disableCartQuantity();

                var $main = $(options.mainContSelector);

                if (!$main.length) {
                    return;
                }

                var $customFields = $main.find(options.customFieldsSelector);

                if (tryInitSquareFromPackagesCalculator($main, $customFields)) {
                    return;
                }

                if (tryInitSquareFromRollsCalculator($main, $customFields)) {
                    return;
                }

                tryInitSquareFromWidthCalculator($main, $customFields);
            });
        }
    };
})(window.jQuery);